import { useState } from 'react';
import MediaSlider from './components/MediaSlider';
import parse from 'html-react-parser';
import formatMinutes from './utils/formatMinutes';
import './scss/Intro.scss';

function Intro({ intro }) {

  const [isExpanded, setIsExpanded] = useState(false)

  return(
    <section id="intro">
      <h1 id="recipe-title" className="section-header">{intro.title}</h1>
      <div className="section-content">
        <h4 id="recipe-description" className="family">{intro.description}</h4>
        <p id="recipe-info">
          {intro.timing 
           ? intro.timing
           : `Prep: ${formatMinutes(intro.prepTime)} • Cook time: ${formatMinutes(intro.cookTime)} • Total time: ${formatMinutes(intro.totalTime)}`
          }
        </p>
        <MediaSlider media={intro.media} thumbnails={intro.thumbnails} />
        <div id="recipe-story" className='textBlock' data-expanded={isExpanded}>
          <p id="recipe-story-intro">{parse(intro.storySummary)}</p>
          {intro.storyMore && (
            <> 
            <span id="recipe-story-more">{parse(intro.storyMore)}</span>
            <button 
              onClick={() => setIsExpanded(!isExpanded)}
            >Read {!isExpanded ? "more" : "less"}
            </button>
            </>
          )}
        </div>
      </div>
    </section>
  )
}

export default Intro;